import { updateLinksAttributes } from '../utils.js';

export default function customSeoBlock() {
  const widgetName = 'customSeoBlock';
  const widgetOpts = customSeoBlockOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description"><p>${Description}</p></div>
        ${
          URL == null
            ? ''
            : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>Learn More</a>`
        }
    `);
  }
}
